import { Action } from 'redux';

import { GetSiteSettingsRequest, SiteSettingsRequestSucceeded } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';


export interface GetSiteSettingsRequestAction extends Action {
    readonly siteId: string;
}

export function getSiteSettingsRequest(siteId: string): GetSiteSettingsRequestAction {
  return {
    type: GetSiteSettingsRequest,
    siteId
  };
}

export const isGetSiteSettingsRequest = isActionFactory<GetSiteSettingsRequestAction>(GetSiteSettingsRequest);

export interface SiteSettingsRequestSucceededAction extends Action {
  readonly siteSettings: ISiteSettingsForSiteAdmin;
}

export function siteSettingsRequestSucceeded(siteSettings: ISiteSettingsForSiteAdmin): SiteSettingsRequestSucceededAction {
  return {
    type: SiteSettingsRequestSucceeded,
    siteSettings
  };
}

export const isSiteSettingsRequestSucceeded = isActionFactory<SiteSettingsRequestSucceededAction>(SiteSettingsRequestSucceeded);